<template>
    <div class="input__div">
        <div class="placeholder_div">
            <img :src="require(`@/assets/img/${PlaceholderIconUrl}`)" class="input_placeholder_icon" width="25PX"/>
        </div>
        <div class="input_field_section">
            <input type="text" class="form-contorl" :placeholder="placeholderText"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Input',
    props: ["PlaceholderIconUrl", "placeholderText"],
}
</script>

<style lang="scss">
$primaryColor: rgb(75, 44, 114);

.input__div{
    display: flex;
    justify-content: space-between;
    height: 58px;
    border: 1px solid $primaryColor;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 25px;
    .placeholder_div {
        height: 58px;
        flex: 0 0 15%;
        background: $primaryColor;
        align-self: center;
        justify-self: flex-start;
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 25px;
        border-bottom-right-radius: 22px;
        border-top-right-radius: 22px;
        display: flex;
        justify-content: center;
        .input_placeholder_icon {
            align-self: center;
        }
    }
    .input_field_section {
        flex: 0 0 80%;
        align-self: center;
        justify-self: flex-end;
        input {
            border: none;
            height: 52px;
            width: 90%;
        }
    }
}
input:focus, textarea:focus, select:focus{
    outline: none;
}
</style>